<template>
  <b-form
    ref="standingsForm"
    novalidate
    :validated="validated">
    <b-form-group
      label="Default Tab"
      description="Valid values are 0-2">
      <b-spinbutton
        v-model="standings.defaultTab"
        min="0"
        max="2"
        inline />
    </b-form-group>
    <b-form-group
      label="Season"
      label-cols="1">
      <b-input 
        v-model.number="standings.season"
        number
        type="number"
        cols="4"
        class="width-150" />
    </b-form-group>
    <b-form-group label="Should Show...">
      <b-checkbox v-model="standings.shouldShowElimination">
        Elimination
      </b-checkbox>
      <b-checkbox v-model="standings.shouldShowWildCardElimination">
        Wild Card Elimination
      </b-checkbox>
      <b-checkbox v-model="standings.shouldShowWildCardGamesBehind">
        Wild Card Games Behind
      </b-checkbox>
      <b-checkbox v-model="standings.shouldShowSpringTrainingTab">
        Spring Training Tab
      </b-checkbox>
      <b-checkbox v-model="standings.shouldShowDivisionTab">
        Division Tab
      </b-checkbox>
      <b-checkbox v-model="standings.shouldShowWildCardTab">
        Wild Card Tab
      </b-checkbox>
      <b-checkbox v-model="standings.shouldShowPostseasonTab">
        Postseason Tab
      </b-checkbox>
      <b-checkbox v-model="standings.shouldShowClinchText">
        Clinch Text
      </b-checkbox>
      <b-checkbox v-model="standings.shouldShowStandingsWildCardOnWatch">
        Standings Wild Card On Watch
      </b-checkbox>
    </b-form-group>
    <b-card header="Tab URLs">
      <b-form-group label="Spring Training">
        <b-input
          v-model="standings.tabUrls.springTraining"
          type="url" />
      </b-form-group>
      <b-form-group label="Postseason">
        <b-input
          v-model="standings.tabUrls.postSeason"
          type="url" />
      </b-form-group>
      <b-form-group label="Regular Season">
        <b-input
          v-model="standings.tabUrls.regularSeason"
          type="url" />
      </b-form-group>
      <b-form-group label="Wild Card">
        <b-input
          v-model="standings.tabUrls.wildCardWithLeaders"
          type="url" />
      </b-form-group>
    </b-card>
  </b-form>
</template>

<script>

export default {
  name: "StandingsForm",
  props: {
    value: {
      type: Object,
      default: () => ({
        "defaultTab": 0,
        "season": new Date().getFullYear(),
        "shouldShowElimination": false,
        "shouldShowWildCardElimination": false,
        "shouldShowWildCardGamesBehind": false,
        "shouldShowSpringTrainingTab": false,
        "shouldShowDivisionTab": false,
        "shouldShowWildCardTab": false,
        "shouldShowPostseasonTab": false,
        "shouldShowClinchText": false,
        "shouldShowStandingsWildCardOnWatch": false,
        "tabUrls": {
          "springTraining": "https://www.mlb.com/app/atbat${alt-supp-lang-path}/standings/spring-training?",
          "postSeason": "https://www.mlb.com/app/atbat${alt-supp-lang-path}/standings/postseason?",
          "regularSeason": "https://www.mlb.com/app/atbat${alt-supp-lang-path}/divisional?",
          "wildCardWithLeaders": "https://www.mlb.com/app/atbat${alt-supp-lang-path}/wild-card?",
        },
      }),
    },
  },
  data: () => ({
    validated: false,
  }),
  computed: {
    standings: {
      get: function () {
        return this.value
      },
      set: function (value) {
        this.$emit("input", value)
      },
    },
  },
  methods: {
    isValid() {
      this.validated = true
      return this.$refs.standingsForm.checkValidity()
    },
  },
}
</script>

<style scoped>
.width-150 {
  width: 150px;
}
</style>
